import { NgModule } from '@angular/core';
import { ForgotComponent } from '../components/authentication/forgot/forgot.component';
import { LoginComponent } from '../components/authentication/login/login.component';
import { PasswordResetComponent } from '../components/authentication/password-reset/password-reset.component';
import { RegisterComponent } from '../components/authentication/register/register.component';
import { VerifyComponent } from '../components/authentication/verify/verify.component';
import { ContactComponent } from '../components/bed-institut-wissen/about/contact/contact.component';
import { PhilosophyComponent } from '../components/bed-institut-wissen/about/philosophy/philosophy.component';
import { AboutLecturersComponent } from '../components/bed-institut-wissen/about/lecturers/lecturers.component';
import { CooperationsComponent } from '../components/bed-institut-wissen/about/cooperations/cooperations.component';
import { TeamComponent } from '../components/bed-institut-wissen/about/team/team.component';
import { LecturerSeminarsComponent } from '../components/bed-institut-wissen/lecturer-seminars/lecturer-seminars.component';
import { AdministrationComponent } from '../components/bed-institut-wissen/administration/administration.component';
import { BookingOverviewComponent } from '../components/bed-institut-wissen/administration/bookings/booking-overview/booking-overview.component';
import { BookingsComponent } from '../components/bed-institut-wissen/administration/bookings/bookings.component';
import { ContactAppointmentsComponent } from '../components/bed-institut-wissen/administration/contacts/contact-appointments/contact-appointments.component';
import { ContactBookingsComponent } from '../components/bed-institut-wissen/administration/contacts/contact-bookings/contact-bookings.component';
import { ContactMemberAreasComponent } from '../components/bed-institut-wissen/administration/contacts/contact-member-areas/contact-member-areas.component';
import { ContactsFormularComponent } from '../components/bed-institut-wissen/administration/contacts/contacts-formular/contacts-formular.component';
import { ContactsComponent } from '../components/bed-institut-wissen/administration/contacts/contacts.component';
import { CouponUsageLogComponent } from '../components/bed-institut-wissen/administration/coupons/coupon-usage-log/coupon-usage-log.component';
import { AdminCouponsComponent } from '../components/bed-institut-wissen/administration/coupons/coupons.component';
import { PromoCodesComponent } from '../components/bed-institut-wissen/administration/coupons/promo-codes/promo-codes.component';
import { SellableCodesComponent } from '../components/bed-institut-wissen/administration/coupons/sellable-codes/sellable-codes.component';
import { InvoiceDetailsComponent } from '../components/bed-institut-wissen/administration/invoices/invoice-details/invoice-details.component';
import { InvoicesComponent } from '../components/bed-institut-wissen/administration/invoices/invoices.component';
import { MemberAreaFormularComponent } from '../components/bed-institut-wissen/administration/member-areas/member-area-formular/member-area-formular.component';
import { MemberAreasAdministrationComponent } from '../components/bed-institut-wissen/administration/member-areas/member-areas.component';
import { NewsBannerCategoryCardComponent } from '../components/bed-institut-wissen/administration/news-banners/news-banner-formular/news-banner-category-card/news-banner-category-card.component';
import { NewsBannerFormularComponent } from '../components/bed-institut-wissen/administration/news-banners/news-banner-formular/news-banner-formular.component';
import { NewsBannerSlideSequenceComponent } from '../components/bed-institut-wissen/administration/news-banners/news-banner-slide-sequence/news-banner-slide-sequence.component';
import { NewsBannersComponent } from '../components/bed-institut-wissen/administration/news-banners/news-banners.component';
import { SeminarAttachmentsComponent } from '../components/bed-institut-wissen/administration/seminars/seminar-attachments/seminar-attachments.component';
import { SeminarAttendeesComponent } from '../components/bed-institut-wissen/administration/seminars/seminar-attendees/seminar-attendees.component';
import { AdminSeminarDetailsComponent } from '../components/bed-institut-wissen/administration/seminars/seminar-details/seminar-details.component';
import { SeminarFileSequenceComponent } from '../components/bed-institut-wissen/administration/seminars/seminar-file-sequence/seminar-file-sequence.component';
import { SeminarPreviewComponent } from '../components/bed-institut-wissen/administration/seminars/seminar-preview/seminar-preview.component';
import { SeminarsFormularComponent } from '../components/bed-institut-wissen/administration/seminars/seminars-formular/seminars-formular.component';
import { SeminarsComponent } from '../components/bed-institut-wissen/administration/seminars/seminars.component';
import { TrainingCategoriesFormularComponent } from '../components/bed-institut-wissen/administration/training-categories/training-categories-formular/training-categories-formular.component';
import { TrainingCategoriesComponent } from '../components/bed-institut-wissen/administration/training-categories/training-categories.component';
import { AdvancedtrainingComponent } from '../components/bed-institut-wissen/advancedtraining/advancedtraining.component';
import { CartInvoiceFormularComponent } from '../components/bed-institut-wissen/cart/cart-invoice-formular/cart-invoice-formular.component';
import { CartSuccessComponent } from '../components/bed-institut-wissen/cart/cart-success/cart-success.component';
import { CartComponent } from '../components/bed-institut-wissen/cart/cart.component';
import { CouponsComponent } from '../components/bed-institut-wissen/coupons/coupons.component';
import { HomeComponent } from '../components/bed-institut-wissen/home/home.component';
import { MemberAreasComponent } from '../components/bed-institut-wissen/member-areas/member-areas.component';
import { SeminarComponent } from '../components/bed-institut-wissen/seminar/seminar.component';
import { CollegesComponent } from '../components/bed-institut-wissen/service/colleges/colleges.component';
import { LecturersComponent } from '../components/bed-institut-wissen/service/lecturers/lecturers.component';
import { ParticipantsComponent } from '../components/bed-institut-wissen/service/participants/participants.component';
import { UserAppointmentsComponent } from '../components/bed-institut-wissen/user/appointments/appointments.component';
import { UserBookingDetailsComponent } from '../components/bed-institut-wissen/user/bookings/booking-details/booking-details.component';
import { UserBookingsComponent } from '../components/bed-institut-wissen/user/bookings/bookings.component';
import { UserLibraryComponent } from '../components/bed-institut-wissen/user/library/library.component';
import { UserComponent } from '../components/bed-institut-wissen/user/user.component';
import { InstitutWissenComponent } from '../components/institut-wissen.component';
import { BookingDetailsComponent } from '../components/shared-components/booking/booking-details/booking-details.component';
import { LecturerCardComponent } from '../components/shared-components/lecturer-card/lecturer-card.component';
import { LecturerVitaComponent } from '../components/shared-components/lecturer-vita/lecturer-vita.component';
import { SeminarCardsComponent } from '../components/shared-components/seminar/seminar-cards/seminar-cards.component';
import { SeminarRegistrationComponent } from '../components/shared-components/seminar/seminar-registration/seminar-registration.component';
import { SeminarTableComponent } from '../components/shared-components/seminar/seminar-table/seminar-table.component';
import { SharedModule } from './shared-module';

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    ForgotComponent,
    VerifyComponent,
    AdministrationComponent,
    HomeComponent,
    InstitutWissenComponent,
    CouponsComponent,
    TeamComponent,
    AboutLecturersComponent,
    CooperationsComponent,
    PhilosophyComponent,
    ContactComponent,
    LecturerCardComponent,
    LecturerSeminarsComponent,
    CollegesComponent,
    LecturersComponent,
    ParticipantsComponent,
    TrainingCategoriesComponent,
    TrainingCategoriesFormularComponent,
    SeminarsComponent,
    SeminarsFormularComponent,
    AdminSeminarDetailsComponent,
    NewsBannersComponent,
    InvoicesComponent,
    AdminCouponsComponent,
    ContactsComponent,
    BookingsComponent,
    BookingDetailsComponent,
    SeminarTableComponent,
    SeminarCardsComponent,
    AdvancedtrainingComponent,
    PasswordResetComponent,
    ContactsFormularComponent,
    LecturerVitaComponent,
    UserComponent,
    UserLibraryComponent,
    UserAppointmentsComponent,
    UserBookingsComponent,
    UserBookingDetailsComponent,
    SeminarRegistrationComponent,
    BookingOverviewComponent,
    InvoiceDetailsComponent,
    SeminarComponent,
    SeminarAttendeesComponent,
    SeminarAttachmentsComponent,
    SeminarPreviewComponent,
    ContactAppointmentsComponent,
    ContactBookingsComponent,
    ContactMemberAreasComponent,
    NewsBannersComponent,
    NewsBannerFormularComponent,
    NewsBannerSlideSequenceComponent,
    NewsBannerCategoryCardComponent,
    PromoCodesComponent,
    SellableCodesComponent,
    CouponUsageLogComponent,
    CartComponent,
    CartSuccessComponent,
    CartInvoiceFormularComponent,
    SeminarFileSequenceComponent,
    MemberAreaFormularComponent,
    MemberAreasAdministrationComponent,
    MemberAreasComponent,
  ],
  imports: [SharedModule],
  exports: [HomeComponent, SharedModule, InstitutWissenComponent],
  providers: [],
  bootstrap: [],
})
export class InstitutWissenModule {}
